var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWethLz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2024_4954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.3734,
    cy: 28.96,
    rx: 11.7333,
    ry: 3.47363,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2424 6.12012C23.7852 4.27016 20.7159 3.1715 17.3867 3.1715C9.31593 3.1715 2.77331 9.62793 2.77331 17.5923C2.77331 20.8756 3.88519 23.9026 5.75764 26.3267C2.25814 23.692 0 19.5334 0 14.8544C0 6.89003 6.54262 0.433594 14.6133 0.433594C19.357 0.433594 23.5727 2.66402 26.2424 6.12012Z",
    fill: "#D93878"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6133 27.8016C21.8593 27.8016 27.7334 22.005 27.7334 14.8544C27.7334 7.70391 21.8593 1.90726 14.6133 1.90726C7.36737 1.90726 1.49333 7.70391 1.49333 14.8544C1.49333 22.005 7.36737 27.8016 14.6133 27.8016ZM14.6133 29.2753C22.6841 29.2753 29.2267 22.8189 29.2267 14.8544C29.2267 6.89003 22.6841 0.433594 14.6133 0.433594C6.54262 0.433594 0 6.89003 0 14.8544C0 22.8189 6.54262 29.2753 14.6133 29.2753Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.3867,
    cy: 17.5927,
    rx: 14.6133,
    ry: 14.4208,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3123 20.4338V14.9219H25.6623V17.1342H27.8632V14.9219H29.2104V20.4338H27.8632V18.2188H25.6623V20.4338H24.3123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8552 16.0038V14.9219H23.5761V16.0038H21.8824V20.4338H20.5515V16.0038H18.8552Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2212 20.4338V14.9219H18.1157V16.0038H15.5712V17.1342H17.9167V18.2188H15.5712V19.3518H18.1157V20.4338H14.2212Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.30844 20.4338L5.68298 14.9219H7.1748L8.01753 18.5337H8.0639L9.02662 14.9219H10.243L11.2057 18.5417H11.2521L12.0975 14.9219H13.5866L11.9639 20.4338H10.663L9.65662 17.0911H9.61299L8.60662 20.4338H7.30844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3867 30.5399C24.6326 30.5399 30.5067 24.7433 30.5067 17.5927C30.5067 10.4422 24.6326 4.64554 17.3867 4.64554C10.1407 4.64554 4.26665 10.4422 4.26665 17.5927C4.26665 24.7433 10.1407 30.5399 17.3867 30.5399ZM17.3867 32.0136C25.4574 32.0136 32 25.5571 32 17.5927C32 9.62831 25.4574 3.17188 17.3867 3.17188C9.31593 3.17188 2.77332 9.62831 2.77332 17.5927C2.77332 25.5571 9.31593 32.0136 17.3867 32.0136Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2024_4954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.433594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWethLz);
export default __webpack_public_path__ + "static/media/wethLZ.2fc0f8960906017ded501b14f86d24f3.svg";
export { ForwardRef as ReactComponent };